import { WidgetColors } from '../models/reader-document';

export const DEFAULT_COLORS: WidgetColors = {
  accent: '#ff5e38',
  title: '#111827',
  subtitle: '#4b5563',
  primary: '#111827',
  background: 'transparent',
};

export const DEFAULT_PADDING = {
  top: 0,
  bottom: 0,
};